module.exports = __webpack_public_path__ + "static/media/hiddenPerson.1395b688.png";